import './style/UploadedFilesComponent.scss';
import UploadedFilesComponent from "./js/UploadedFilesComponent";

export default UploadedFilesComponent;
